module.exports = __webpack_public_path__ + "img/3.b3ff24e9.jpg";